import { ClockIcon, GaugeIcon, SignalIcon, UsersIcon } from "lucide-react";

import { Row, TableTooltipParagraph, TimeAgoInTableCell } from "@/components";
import { TableJobDifficultyBadge } from "@/components/job-tracker/badges/TableJobDifficultyBadge";
import { TableJobUrgencyBadge } from "@/components/job-tracker/badges/TableJobUrgencyBadge";
import { Badge } from "@/components/ui/badge";
import {
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import { useTaggableUsers } from "@/contexts/TaggableUsersContext";
import { JobUpdate } from "@/types";

export const JobDifficultyUrgencyHistory = ({
  jobUpdates,
}: {
  jobUpdates: JobUpdate[];
}) => {
  /* Misc Hooks */
  const { userNameMap } = useTaggableUsers();

  const render = () => {
    if (jobUpdates.length === 0) return null;

    return (
      <div className="relative overflow-auto rounded-lg border border-slate-200">
        <table className="w-full table-fixed text-sm">
          <TableHeader className="sticky top-0 bg-slate-50 [&_tr]:border-b-0">
            <TableRow className="sticky-border-bottom">
              <TableHead className="w-[25%]">
                <Row className="items-center gap-2 text-slate-700">
                  <GaugeIcon className="h-4 w-4" />
                  Difficulty
                </Row>
              </TableHead>
              <TableHead className="w-[25%]">
                <Row className="items-center gap-2 text-slate-700">
                  <SignalIcon className="h-4 w-4" />
                  Urgency
                </Row>
              </TableHead>
              <TableHead className="w-[25%]">
                <Row className="items-center gap-2 text-slate-700">
                  <ClockIcon className="h-4 w-4" />
                  Created At
                </Row>
              </TableHead>
              <TableHead className="w-[25%]">
                <Row className="items-center gap-2 text-slate-700">
                  <UsersIcon className="h-4 w-4" />
                  Created By
                </Row>
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {jobUpdates.map((entry) => (
              <TableRow key={entry.id}>
                <TableCell className="px-2">
                  {entry.difficulty != null ? (
                    <TableJobDifficultyBadge difficulty={entry.difficulty} />
                  ) : null}
                </TableCell>
                <TableCell className="px-2">
                  {entry.urgency != null ? (
                    <TableJobUrgencyBadge urgency={entry.urgency} />
                  ) : null}
                </TableCell>
                <TableCell>
                  <TimeAgoInTableCell timestamp={entry.createdAt} />
                </TableCell>
                <TableCell>
                  <Badge className="max-w-full" variant="secondary">
                    <TableTooltipParagraph text={userNameMap[entry.userId]} />
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </table>
      </div>
    );
  };

  return render();
};
